import React from "react";

export default function Logo({ light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-md bg-white shadow-sm ring-1 ring-black/5">
        <img src="/kilted-logo-mark.png" alt="The Kilted Courier" className="h-8 w-8 object-contain" data-testid="brand-logo-image" />
      </div>
      <div className="leading-tight">
        <div className={`font-heading text-base font-extrabold tracking-tight ${light ? "text-white" : "text-kilted-green"}`}>
          The Kilted Courier
        </div>
        <div className={`text-[10px] font-medium tracking-widest uppercase ${light ? "text-kilted-gold" : "text-kilted-gold"}`}>
          Monaro · NSW Delivery
        </div>
      </div>
    </div>
  );
}
